import { Component, OnInit } from '@angular/core';
import { LivePreviewService } from '../../../shared/services/live-preview.service';
import { Store } from '@ngrx/store';
import { IState } from '../../../../shared/models/state';
import { getActiveProjectSelector } from '../../../projects/projects.reducer';

@Component({
  selector: 'cc-lg-live-preview-bubble',
  templateUrl: './live-preview-bubble.component.html',
  styleUrls: ['./live-preview-bubble.component.scss']
})
export class LivePreviewBubbleComponent implements OnInit {
  public previewHtml: any;
  public state = 'BUBBLE';
  private projectId: number;

  constructor(private livePreviewService: LivePreviewService, private store: Store<IState>) {}

  ngOnInit(): void {
    this.store.select(getActiveProjectSelector).subscribe(data => {
      this.projectId = data && data.projectId;
    });
    this.previewHtml = this.livePreviewService.createPreviewHtml({ bubbleEditMode: true, projectId: this.projectId });
    this.changeState('BUBBLE');
  }

  changeState(state: 'BUBBLE' | 'BOX') {
    this.livePreviewService.sendToFrame('SWITCH_STATE_IN_EDIT_MODE', state);
    this.state = state;
  }
}
